import React from 'react';
import CheckSuccessIcon from '@src/icons/check-success.svg';
import styled from 'styled-components';
import { LayoutColors } from '@src/core/theme';
import { device } from '@src/common/breakpoints';
import { BodyLarge, BodyRegularSemiBold } from '@src/fonts/typography/Typography';

interface SuccessModalProps {
  textInfo: string;
  textButton: string;
  handleClose: () => void;
}

const SuccessModal = ({ textInfo, textButton, handleClose }: SuccessModalProps) => {
  return (
    <ModalMessageContainer>
      <ModalMessageInfo>
        <CheckSuccessIcon />
        {textInfo}
      </ModalMessageInfo>
      <ModalMessageButton onClick={handleClose}>{textButton}</ModalMessageButton>
    </ModalMessageContainer>
  );
};

const ModalMessageContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  flex-direction: column;
  background: ${LayoutColors.whiteDark};
  border-radius: 8px;
  width: 95%;
  padding: 16px;
  margin: 50% auto;
  ${device.smallTablet} {
    margin: 15% auto;
    padding: 76px 60px;
    max-width: 577px;
    max-height: 289px;
  }
`;

const ModalMessageInfo = styled.p`
  ${BodyLarge};
  display: flex;
  color: #30a678;
  text-align: center;
  border-radius: 8px;
  padding: 20px;
  width: fit-content;
  align-itens: end;
  background-color: rgba(48, 166, 120, 0.1);
  gap: 10px;
`;

const ModalMessageButton = styled.button`
  ${BodyRegularSemiBold};
  color: ${LayoutColors.whiteLight};
  width: 70%;
  padding: 10px 47px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  background-color: ${LayoutColors.successDark};
`;

export default SuccessModal;
